import { render, staticRenderFns } from "./DatatableButtons.vue?vue&type=template&id=04f64f34"
import script from "./DatatableButtons.vue?vue&type=script&lang=js"
export * from "./DatatableButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports